import * as React from "react";
const SvgFiBrandsXd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-xd_svg__a)">
      <path
        fill="#151A2D"
        d="M19.75.3H4.25A4.25 4.25 0 0 0 0 4.55v14.9a4.25 4.25 0 0 0 4.25 4.25h15.5A4.25 4.25 0 0 0 24 19.45V4.55A4.25 4.25 0 0 0 19.75.3m-6.908 16.466c-.011.038-.048.014-.112.025h-2.287c-.161 0-.273-.006-.338-.113q-.322-.629-.644-1.248a47 47 0 0 0-.684-1.264q-.362-.645-.717-1.304h-.015a53 53 0 0 1-.668 1.288q-.346.644-.684 1.28T6 16.694c-.043.096-.119.106-.226.106H3.569c-.043 0-.067.017-.073-.026a.16.16 0 0 1 .024-.112l3.107-5.104L3.6 6.438q-.047-.064-.016-.105a.12.12 0 0 1 .097-.04h2.27a.3.3 0 0 1 .145.024.3.3 0 0 1 .097.089q.29.644.644 1.288.353.644.716 1.272.362.628.668 1.272h.016q.322-.66.653-1.288.33-.629.676-1.264.347-.636.668-1.264a.25.25 0 0 1 .064-.105.23.23 0 0 1 .129-.024h2.109a.093.093 0 0 1 .112.067.1.1 0 0 1-.031.094l-2.994 4.942 3.204 5.249a.17.17 0 0 1 .015.12m7.567-.394a8 8 0 0 1-1.626.483 9 9 0 0 1-1.545.145 5 5 0 0 1-2.15-.45 3.4 3.4 0 0 1-1.505-1.361q-.547-.909-.547-2.278a4.2 4.2 0 0 1 .547-2.11 4 4 0 0 1 1.594-1.544q1.046-.58 2.528-.58.08 0 .209.009l.306.024V5.536q0-.113.097-.113h2.029a.086.086 0 0 1 .097.097v9.515q0 .273.024.596t.04.579a.17.17 0 0 1-.098.162m-2.785-5.83a2.5 2.5 0 0 0-1.127.258c-.341.17-.632.425-.845.74q-.33.484-.33 1.273c-.007.35.05.7.169 1.03.098.266.251.508.451.708.191.185.422.322.676.403.268.087.548.13.829.129q.225 0 .419-.016.18-.015.354-.065v-4.395a2 2 0 0 0-.266-.048q-.165-.015-.33-.016"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-xd_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsXd;
